import axios from 'axios'
import { getCookie } from '@/utils/cookie-utils.js'
import client from './client'
import store from '@/store/index'

const clientNotifier = axios.create({ baseURL: client.defaults.baseURL })

clientNotifier.interceptors.request.use(
	(config) => {
		config.headers.Authorization = getCookie('token')
		return config
	}
)

clientNotifier.interceptors.response.use(
	(res) => {
		console.log('res')
		console.log(res)
		store.commit('notify', {
			message: res.data.message,
			color: 'primary'
		})
		return res
	},
	(err) => {
		console.log('err')
		console.log(err)
		if (err.response) {
			store.commit('notify', {
				message: err.response.data.message,
				color: 'red'
			})
		}
		if (err.response.status === 404) {
			throw new Error(`${err.config.url} not found`)
		}
		throw err
	}
)

export default clientNotifier